import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as highcharts from "highcharts";
import { Chart } from 'angular-highcharts';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-basicdonut-chart',
  templateUrl: './basicdonut-chart.component.html',
  styleUrls: ['./basicdonut-chart.component.scss']
})
export class BasicdonutChartComponent implements OnInit {
  chartOptions = {}
  @Input() data: any;
  @Output() chartClick = new EventEmitter<{ name: string; value: number }>(); // ✅ Emit event to parent
  Highcharts: typeof Highcharts = Highcharts;
  @Input('data')
  set in(val){
    this.plotChart(val)
  }
  highcharts = highcharts
  constructor() { }
  donutChart: Chart;

  ngOnInit(): void {
  }
  plotChart(data) {
    return this.chartOptions =  {
      chart: {
        type: 'pie',
        height: 250
      },
      title: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.2f}</b>'
      },
      credits: {
        enabled: false
      },
      // legend: {
      //   align: 'right', 
      //   verticalAlign: 'bottom', 
      //   layout: 'vertical', 
      //   x: -50, 
      //   y: 20, 
      //   itemStyle: {
      //     fontSize: '14px', 
      //     color: '#2C3A43'
      //   }
      // },
      plotOptions: {
        pie: {
          // innerSize: '50%',
          innerSize: '60%',
          size: '90%', 
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: ' {point.y}',
            style: {
              fontSize: '14px',
              color: '#000'
            },
            distance: 10 
          },
          showInLegend: false,
          startAngle: -90,
          endAngle: -180,
          point: {
            events: {
              // click: function (event: any) {
              //   alert(`Clicked on: ${this.name} - Value: ${this.y}`);
              // },
              // click: (event: any) => {
              //   this.showAlertReasons(event.point.name, event.point.y);
              // },
              click: (event: any) => {
                this.chartClick.emit({ name: event.point.name, value: event.point.y }); // ✅ Emit to parent
              },
            },
          },
        }
      },
      series: data.series
    };
  }
}
